const { VUE_APP_BASE_DOMAIN } = process.env;
const baseURL = `${VUE_APP_BASE_DOMAIN}api/`;
export default {
    baseURL
};
